
const NS = 'GiftCardsV1Ctrl';

export default function GiftCardsV1Ctrl(
  $log: any, $state: any, $rootScope: any, $mdToast: any, $scope: any
) {
  "ngInject";

  var vm = this;

  /**
   * Copied same hierarchy structure as "reports", just in case we need more Gift Cards pages copied over
   * from Admin in future.
   */

  vm.pages = [{
    name: 'Gift Cards Management',
    path: 'giftcards.management'
  }];

}
